import { FC } from 'react'
import { ComponentProps } from 'src/types/component'

export const Tab: FC<ComponentProps> = ({ children }) => children
